import { DatePipe } from '@angular/common';
import { EventEmitter } from '@angular/core';
import { IPedidos } from '@app/modules/pedidos/model/pedidos.model';
import { COLUMN_DATA_TYPE, TokenService, User } from 'viggo-sistemas-core-web';

export class BuildGerenciamentoColumns {
  isTheLastProcess: boolean;
  onSendPedidoConcluido: EventEmitter<IPedidos[]>;
  onSendPedido: EventEmitter<IPedidos[]>;
  datePipe: DatePipe;
  showBtnActionsPartes: boolean;
  tokenService: TokenService;
  moduleName: string;
  moduleNameExpanded: string;

  constructor(
    isTheLastProcess: boolean,
    onSendPedidoConcluido: EventEmitter<IPedidos[]>,
    onSendPedido: EventEmitter<IPedidos[]>,
    datePipe: DatePipe,
    showBtnActionsPartes: boolean,
    tokenService: TokenService,
    moduleName: string,
    moduleNameExpanded: string
  ) {
    this.isTheLastProcess = isTheLastProcess;
    this.onSendPedidoConcluido = onSendPedidoConcluido;
    this.onSendPedido = onSendPedido;
    this.datePipe = datePipe;
    this.showBtnActionsPartes = showBtnActionsPartes;
    this.tokenService = tokenService;
    this.moduleName = moduleName;
    this.moduleNameExpanded = moduleNameExpanded;
  }

  refreshColumnsUser(cols, colsExpanded) {
    const user = this.tokenService.getUser() as User;
    const userColumns = user.settings['colunas'] as any[];
    const index = userColumns.findIndex(col => col.module === this.moduleName);
    const indexExpanded = userColumns.findIndex(
      col => col.module === this.moduleNameExpanded
    );
    if (index === -1) {
      userColumns.push({
        module: this.moduleName,
        colunas: cols
      });
    }
    if (indexExpanded === -1) {
      userColumns.push({
        module: this.moduleNameExpanded,
        colunas: colsExpanded
      });
    }
    this.tokenService.refreshUser(user);
  }

  buildColumnsMobile() {
    return [
      {
        field: 'numero',
        header_name: 'Nº',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'pre_cadastro_nome_razao_social',
        header_name: 'Cliente',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'vendedor_apelido_nome_fantasia',
        header_name: 'Vendedor',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'modelo_descricao',
        header_name: 'Modelo',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'quantidade',
        header_name: 'Qtd.',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: true,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'data_hora',
        header_name: 'Criado dia',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          this.datePipe.transform(item.data_hora, 'shortDate')
      },
      {
        field: 'referencia',
        header_name: 'Referência',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'previsao_entrega',
        header_name: 'Entregar dia',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          this.datePipe.transform(item.previsao_entrega, 'shortDate'),
        iconClass: ({ dias_alerta }) =>
          (dias_alerta as string).includes('EM_ATRASO')
            ? 'ml-2 pi pi-fw pi-circle-fill text-red'
            : (dias_alerta as string).includes('EM_ALERTA')
            ? 'ml-2 pi pi-fw pi-circle-fill text-orange-500'
            : 'ml-2 pi pi-fw pi-circle-fill text-green-500',
        iconToolTip: ({ dias_alerta }) =>
          (dias_alerta as string).includes('EM_ATRASO')
            ? `Pedido está ${
                (dias_alerta as string).split('_')[2]
              } dia(s) atrasado!`
            : (dias_alerta as string).includes('EM_ALERTA')
            ? `Alerta: prazo se vence em ${
                (dias_alerta as string).split('_')[2]
              } dia(s)!`
            : `Pedido dentro do prazo! Faltam ${
                (dias_alerta as string).split('_')[2]
              } dia(s) para se vencer.`
      },
      {
        field: 'status',
        header_name: 'Status do pedido',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string => item.status.replace(/_/gi, ' ')
      },
      {
        field: 'is_processo_finalizado',
        header_name: 'Status do processo',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          item.is_processo_finalizado
            ? 'FINALIZADO'
            : item.has_erro_pendente
            ? 'ERRO'
            : item.is_processo_iniciado
            ? 'EM ANDAMENTO'
            : 'AGUARDANDO'
      },
      {
        field: 'actions',
        header_name: 'Ações',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        useBtnAction: true,
        cellRenderer: (item): void =>
          this.isTheLastProcess
            ? this.onSendPedidoConcluido.emit(item)
            : this.onSendPedido.emit(item)
      }
    ];
  }

  buildColumnsDefault() {
    return [
      {
        field: 'numero',
        header_name: 'Nº',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'pre_cadastro_nome_razao_social',
        header_name: 'Cliente',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'vendedor_apelido_nome_fantasia',
        header_name: 'Vendedor',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'modelo_descricao',
        header_name: 'Modelo',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'quantidade',
        header_name: 'Qtd.',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: true,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'data_hora',
        header_name: 'Criado dia',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          this.datePipe.transform(item.data_hora, 'shortDate')
      },
      {
        field: 'referencia',
        header_name: 'Referência',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'previsao_entrega',
        header_name: 'Entregar dia',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          this.datePipe.transform(item.previsao_entrega, 'shortDate'),
        iconClass: ({ dias_alerta }) =>
          (dias_alerta as string).includes('EM_ATRASO')
            ? 'ml-2 pi pi-fw pi-circle-fill text-red'
            : (dias_alerta as string).includes('EM_ALERTA')
            ? 'ml-2 pi pi-fw pi-circle-fill text-orange-500'
            : 'ml-2 pi pi-fw pi-circle-fill text-green-500',
        iconToolTip: ({ dias_alerta }) =>
          (dias_alerta as string).includes('EM_ATRASO')
            ? `Pedido está ${
                (dias_alerta as string).split('_')[2]
              } dia(s) atrasado!`
            : (dias_alerta as string).includes('EM_ALERTA')
            ? `Alerta: prazo se vence em ${
                (dias_alerta as string).split('_')[2]
              } dia(s)!`
            : `Pedido dentro do prazo! Faltam ${
                (dias_alerta as string).split('_')[2]
              } dia(s) para se vencer.`
      },
      {
        field: 'status',
        header_name: 'Status do pedido',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string => item.status.replace(/_/gi, ' ')
      },
      {
        field: 'is_processo_finalizado',
        header_name: 'Status do processo',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (item): string =>
          item.is_processo_finalizado
            ? 'FINALIZADO'
            : item.has_erro_pendente
            ? 'ERRO'
            : item.is_processo_iniciado
            ? 'EM ANDAMENTO'
            : 'AGUARDANDO'
      },
      {
        field: 'actions',
        header_name: 'Ações',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        useBtnAction: true,
        cellRenderer: (item): void =>
          this.isTheLastProcess
            ? this.onSendPedidoConcluido.emit(item)
            : this.onSendPedido.emit(item)
      }
    ];
  }

  buildColumnsExpandedMobile() {
    const cols = [
      {
        field: 'peca_descricao',
        header_name: 'Peça (Nº)',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        cellRenderer(rowValue) {
          return `${rowValue.peca_descricao} (${rowValue.numero})`;
        },
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'materia_prima_descricao',
        header_name: 'Tecido',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'materia_prima_adicional_descricao',
        header_name: 'Forro',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (parte): string =>
          parte.materia_prima_adicional_descricao
            ? parte.materia_prima_adicional_descricao
            : 'Sem Forro'
      },
      {
        field: 'quantidade',
        header_name: 'Quantidade',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: true,
        total: false,
        type: COLUMN_DATA_TYPE.INT
      },
      {
        field: 'servicos',
        header_name: 'Serviços',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        isAction: true,
        lblClick: (parte): void => parte.servicos.length,
        disableActionInfo: (parte): boolean => parte.servicos.length === 0
      },
      {
        field: 'adicionais',
        header_name: 'Adicionais',
        active: false,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        isAction: true,
        lblClick: (parte): void => parte.adicionais.length,
        disableActionInfo: (parte): boolean => parte.adicionais.length === 0
      },
      {
        field: 'etapa_descricao',
        header_name: 'Setor',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'status',
        header_name: 'Status',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        iconClass: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-exclamation-circle text-red-500';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-check-circle text-green-500';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-thumbs-up text-primary';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-spin pi-cog text-yellow-500';
          } else {
            return 'ml-2 pi pi-spin pi-clock text-gray-500';
          }
        },
        iconToolTip: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça com erro! Visualize o erro e corrija-o.';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça finalizada! Encaminhe para a próxima etapa ou conclua a peça.';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'Peça concluída! Aguardando as demais peças para concluir o pedido.';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça em produção! Você pode finalizar a peça ou registrar algum erro.';
          } else {
            return 'Peça ainda sem etapa! Defina qual a próxima etapa de produção da peça.';
          }
        },
        cellRenderer: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Erro';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Finalizado';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'Concluído';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Produzindo';
          } else {
            return 'Aguardando';
          }
        }
      }
    ];
    if (this.showBtnActionsPartes) {
      cols.push({
        field: 'actions',
        header_name: 'Ações',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        useBtnAction: this.showBtnActionsPartes
      } as any);
    }
    return cols;
  }

  buildColumnsExpandedDefault() {
    const cols = [
      {
        field: 'peca_descricao',
        header_name: 'Peça (Nº)',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        cellRenderer(rowValue) {
          return `${rowValue.peca_descricao} (${rowValue.numero})`;
        },
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'materia_prima_descricao',
        header_name: 'Tecido',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'materia_prima_adicional_descricao',
        header_name: 'Forro',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        cellRenderer: (parte): string =>
          parte.materia_prima_adicional_descricao
            ? parte.materia_prima_adicional_descricao
            : 'Sem Forro'
      },
      {
        field: 'quantidade',
        header_name: 'Quantidade',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: true,
        total: false,
        type: COLUMN_DATA_TYPE.INT
      },
      {
        field: 'servicos',
        header_name: 'Serviços',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        isAction: true,
        lblClick: (parte): void => parte.servicos.length,
        disableActionInfo: (parte): boolean => parte.servicos.length === 0
      },
      {
        field: 'adicionais',
        header_name: 'Adicionais',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        isAction: true,
        lblClick: (parte): void => parte.adicionais.length,
        disableActionInfo: (parte): boolean => parte.adicionais.length === 0
      },
      {
        field: 'etapa_descricao',
        header_name: 'Setor',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING
      },
      {
        field: 'status',
        header_name: 'Status',
        active: true,
        removable: true,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        iconClass: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-exclamation-circle text-red-500';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-check-circle text-green-500';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-thumbs-up text-primary';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'ml-2 pi pi-spin pi-cog text-yellow-500';
          } else {
            return 'ml-2 pi pi-spin pi-clock text-gray-500';
          }
        },
        iconToolTip: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça com erro! Visualize o erro e corrija-o.';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça finalizada! Encaminhe para a próxima etapa ou conclua a peça.';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'Peça concluída! Aguardando as demais peças para concluir o pedido.';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Peça em produção! Você pode finalizar a peça ou registrar algum erro.';
          } else {
            return 'Peça ainda sem etapa! Defina qual a próxima etapa de produção da peça.';
          }
        },
        cellRenderer: (parte): string => {
          if (
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Erro';
          } else if (
            parte.is_etapa_iniciada &&
            parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Finalizado';
          } else if (
            parte.is_etapa_iniciada &&
            !parte.has_erro_pendente &&
            parte.status === 'CONCLUIDO'
          ) {
            return 'Concluído';
          } else if (
            parte.etapa &&
            parte.is_etapa_iniciada &&
            !parte.is_etapa_finalizada &&
            !parte.has_erro_pendente &&
            parte.status !== 'CONCLUIDO'
          ) {
            return 'Produzindo';
          } else {
            return 'Aguardando';
          }
        }
      }
    ];
    if (this.showBtnActionsPartes) {
      cols.push({
        field: 'actions',
        header_name: 'Ações',
        active: true,
        removable: false,
        isGroupBy: false,
        group_by: false,
        isTotalizer: false,
        total: false,
        type: COLUMN_DATA_TYPE.STRING,
        useBtnAction: this.showBtnActionsPartes
      } as any);
    }
    return cols;
  }
}
